import { gql } from "@apollo/client";
import { IVendorClient } from "types/Vendor.types";

export interface IGetVendorClientsPaginatedInput {
  search?: string;
  limit: number;
  offset: number;
}

export interface IGetVendorClientsPaginatedResponse {
  getVendorClientsPaginated: {
    vendorClientsPaginated: IVendorClient[];
    total: number;
  };
}

export const GET_VENDOR_CLIENTS_PAGINATED = gql`
  query GetVendorClientsPaginated(
    $getVendorClientsPaginatedInput: GetVendorClientsPaginatedInput!
  ) {
    getVendorClientsPaginated(
      getVendorClientsPaginatedInput: $getVendorClientsPaginatedInput
    ) {
      total
      vendorClientsPaginated {
        id
        name
        country
        countryName
        status
      }
    }
  }
`;

export default {
  GET_VENDOR_CLIENTS_PAGINATED,
};
